import { post } from '../mocks/postsMocks/postsStore';
import UI from '../ui';

const PickIcon: React.FC<{ post: post, animate?: boolean, size?: 12 | 14 }> = ({ post, animate, size = 14 }) => {
  const icon = <UI.Icon name="star" color="chartreuse" size={size} />;
  return (
    <UI.Tooltip title={`This is ${post.user_name}'s favorite hotel in ${post.location.city}`}>
      {animate ? <UI.Animate>{icon}</UI.Animate> : icon}
    </UI.Tooltip>
  );
};

export default PickIcon;
